module.exports = __webpack_public_path__ + "media/svg/youtube-d2a68e9d.svg";